<ng-container *ngIf="appModeService.isApp(); else webCartFallback">
  <section class="cart-page">

    <header class="cart-header">
      <button type="button" class="icon-btn" (click)="goBack()">
        <i *ngIf="!isRTL" class="bi bi-arrow-left"></i>
        <i *ngIf="isRTL" class="bi bi-arrow-right"></i>
      </button>
      <h1>{{ 'APP.CART_TITLE' | translate }}</h1>
      <span class="header-spacer" aria-hidden="true"></span>
    </header>

    <ng-container *ngIf="items$ | async as items">

      <!-- ✅ Cart has items -->
      <ng-container *ngIf="items.length > 0; else emptyCart">
        <section class="cart-content">
          <app-cart-item-card *ngFor="let item of items; trackBy: trackByItem" [item]="item" (remove)="removeItem(item)"
            (incrementQty)="incrementQuantity(item)" (decrementQty)="decrementQuantity(item)"
            (addToFavorite)="addToFavorite(item)">
          </app-cart-item-card>

          <!-- <section class="instructions-box">
            <label for="instructions">{{ 'APP.CART_ORDER_INSTRUCTIONS' | translate }}</label>
            <textarea id="instructions" rows="3"></textarea>
          </section> -->

          <app-order-summary [subtotal]="(subtotal$ | async) || 0" [discount]="(discount$ | async) || 0">
          </app-order-summary>
        </section>

        <!-- ✅ Footer only shows when cart has items -->
        <app-checkout-footer [total]="(totalToPay$ | async) || 0" (checkout)="onCheckout()">
        </app-checkout-footer>
      </ng-container>

      <!-- ✅ Empty state - no footer here -->
      <ng-template #emptyCart>
        <section class="empty-state">
          <p>{{ 'APP.CART_EMPTY' | translate }}</p>
          <button type="button" (click)="continueShopping()">
            {{ 'APP.CART_CONTINUE_SHOPPING' | translate }}
          </button>
        </section>
      </ng-template>

    </ng-container>

  </section>
</ng-container>

<ng-template #webCartFallback>
  <div class="container py-5">
    <h1 class="main-title">Cart</h1>
    <p>Please use the mobile app view for the full cart experience.</p>
  </div>
</ng-template>